<div class="alignment">
  <div class="item"
       [class.active]="alignment === textAlignment.Start"
       (click)="setAlignment(textAlignment.Start)">
    <img [src]="alignLeftUrl">
  </div>
  <div class="item"
       [class.active]="alignment === textAlignment.Middle"
       (click)="setAlignment(textAlignment.Middle)">
    <img [src]="alignMiddleUrl">
  </div>
  <div class="item"
       [class.active]="alignment === textAlignment.End"
       (click)="setAlignment(textAlignment.End)">
    <img [src]="alignRightUrl">
  </div>
</div>
